<template>
  <div class="sky-span">
      <span v-if="filter">{{data , filter | preFilter}}</span>
      <span v-else>{{data}}</span>
  </div>
</template>
<script>
import filters from '@/common/filters'
export default {
  name: 'sky-span',
  props: ['value', 'filter', 'data'],
  inheritAttrs: false,
  data () {
    return {
      val: ''
    }
  },
  methods: {
  },
  watch: {},
  filters: filters
}
</script>
<style scoped lang="scss">

</style>
